<ion-content>
  <ion-header>
    <ion-toolbar>
      <ion-title>{{ username }}'s Profile</ion-title>
      <ion-buttons slot="end">
        <ion-button (click)="cancel()" [strong]="true">Close<ion-icon name="close"></ion-icon></ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>
  <ion-content>
  <!-- Add age and gender display -->
  <ion-row class="ion-justify-content-between ion-align-items-center">
    <div class="chip-container ion-no-padding">
      <ion-col size="auto">
        <div class="chip-row">
          <label class="chip-label">Age</label>
          <ion-chip class="tight-chip" color="primary">
            <ion-label>{{ calculateAge((gameUser$ | async).birthdate) }}</ion-label>
          </ion-chip>
        </div>
      </ion-col>
      <ion-col size="auto">
        <div class="chip-row">
          <label class="chip-label">Gender</label>
          <ion-chip class="tight-chip" color="primary">
            <ion-icon [name]="getGenderIcon((gameUser$ | async).gender)"></ion-icon>
            <ion-label>{{ (gameUser$ | async).gender || 'Unknown' }}</ion-label>
          </ion-chip>
        </div>
      </ion-col>
    </div>
    
    <div class="button-container">
      <ion-col size="auto">
        <ion-button (click)="trailUser()" size="small" fill="solid" color="primary" [hidden]="!(globalService.$loggedIn | async)">
          Trail<ion-icon name="person-add-outline"></ion-icon>
        </ion-button>
      </ion-col>
      <ion-col size="auto">
        <ion-button (click)="openSendMessageModal(username)" size="small" id="send-message-modal" fill="solid" color="medium" [hidden]="!(globalService.$loggedIn | async)">
          <ion-icon name="mail-outline"></ion-icon>
        </ion-button>
      </ion-col>
    </div>
  </ion-row>
    <h5>{{ username }}'s Bio</h5>
    <p>{{ (gameUser$ | async).bio }}</p>
    <ion-accordion-group>
      <ion-accordion value="first">
        <ion-item slot="header" color="light">
          <ion-label>{{ username }}'s Mix Tapes <ion-badge class="large-badge" color="tertiary">{{audio$.value.length}}</ion-badge></ion-label>
        </ion-item>
        <div class="ion-padding" slot="content" *ngFor="let mixTape of getUsersMixTapes(); index as position">
          <ion-item (click)="audioClicked(mixTape)">
            <ion-button>
              <ion-label>{{ mixTape.filename }}</ion-label>
            </ion-button>
          </ion-item>
        </div>
      </ion-accordion>
      <ion-accordion value="second">
        <ion-item slot="header" color="light">
          <ion-label>Users {{ username }} is trailing <ion-badge class="large-badge" color="tertiary">{{gameUser$.value.isTrailing.length}}</ion-badge></ion-label>
        </ion-item>
        <div class="ion-padding" slot="content" *ngFor="let username of getUsersUserIsTrailing(); index as position">
          <ion-item>
            <ion-label>{{ username }}</ion-label>
            <ion-button color="medium" id="profile-viewer-modal" size="small" (click)="openProfileModal(username)">
              View Profile<ion-icon name="person-circle-outline" slot="end"></ion-icon>
            </ion-button>
          </ion-item>
        </div>
      </ion-accordion>
      <ion-accordion value="third">
        <ion-item slot="header" color="light">
          <ion-label>Users trailing {{ username }}<ion-badge class="large-badge" color="tertiary">{{gameUser$.value.isTrailedBy.length}}</ion-badge></ion-label>
        </ion-item>
        <div class="ion-padding" slot="content" *ngFor="let username of getUsersTrailingUser(); index as position">
          <ion-item>
            <ion-label>{{ username }}</ion-label>
            <ion-button color="medium" id="profile-viewer-modal" size="small" (click)="openProfileModal(username)">
              View Profile<ion-icon name="person-circle-outline" slot="end"></ion-icon>
            </ion-button>
          </ion-item>
        </div>
      </ion-accordion>
    </ion-accordion-group>
    <ion-grid>
      <ion-row>
        <ion-col size="6" *ngFor="let photo of photos$ | async; index as position">
            <ion-img [src]="photo.webviewPath" (click)="photoClicked(photo)"></ion-img>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-content>
</ion-content>